import { memo } from "react";

import { defaultToTrue } from "@Components/Modules/Helpers";

export default memo(
    (props: React.SVGProps<SVGSVGElement>) => (
        <svg viewBox="0 0 31.2 29.67" {...props} fill={props.color || "#fff"}>
            <path d="m15.6 0 4.82 9.77 10.78 1.56-7.8 7.6 1.84 10.74-9.64-5.07-9.64 5.07L7.8 18.93 0 11.33l10.78-1.56L15.6 0z" />
        </svg>
    ),
    defaultToTrue,
);
